<template>
 <span>
  <el-button :class="{'btnCreate': true, btn: true}" type="primary" icon="el-icon-download" @click="exportExcel">下载表格</el-button>
 </span>
</template>

<script>
import { exportExcel } from "@/services/downExcel";
import { timestampToDate, delUndefined } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole, isThirdParty } from '@/utils/auth'

export default {
  name: 'DownExcel',
  components: {},
  props: {
    linkStatus: {
      type: String,
      required: false
    },
    listQuery: {
      type: Object,
      required: true
    },
    createTime: {
      type: Array,
      required: false
    },
    total: {
      type: Number,
      required: false
    },
    pageType: {
      type: String,
      required: true
    },
    getListQuery: {
      type: Function,
      required: false
    },
    showDeleted: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      downloadParam: {},
      apiPath: ''
    }
  },
  methods: {
    alertBox(msg) {
      this.$confirm(msg, '', {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        cancelButtonText: '关闭'
      })
        .then(() => {
          console.log()
        })
        .catch(() => {
          console.log()
        });
    },
    exportExcel() {
      if (!navigator.onLine) {
        this.alertBox('网络异常，请检查网络')
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
      const { listQuery, createTime, total, pageType, showDeleted, getListQuery } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (query === 'all') {
          delete _listQuery[key]
        } else if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        } else if (Array.isArray(query)) {
          Object.assign(_listQuery, {
            [key]: query.indexOf('all') > -1 ? null : query.join(',')
          })
        }
      });
      const { payType, study_step, dimension } = _listQuery
      const baseParams = {
        ..._listQuery,
        pageSize: (pageType === 'channel' || pageType === 'org') && total > 1 ? (total + 1) : (total || 1000),
        agent_code: getAgentCode()
      }
      // 体验课订单
      const paramsTrial = {
        orderType: 'desc',
        orderColumn: 'order_time',
        ..._listQuery,
        pageSize: total || 1000,
        start_pay_time: (payType === 'payTime' || pageType === 'thirdpartyTrial') && createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_pay_time: (payType === 'payTime' || pageType === 'thirdpartyTrial') && createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        start_order_time: payType === 'orderTime' && createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_order_time: payType === 'orderTime' && createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      // 精品课
      const paramsOfficial = {
        orderType: 'desc',
        orderColumn: 'order_time',
        ...baseParams,
        ...(getListQuery ? getListQuery() : {})
      }
      // 推广链接
      const paramsLink = {
        ..._listQuery,
        pageSize: total || 1000,
        linkStatus: this.linkStatus,
        teamCode: getTeamCode(),
        agentCode: getAgentCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        showDeleted: showDeleted
      }
      // 学期
      const paramsChannel = {
        ...baseParams,
        b2c_term_start_time: createTime && createTime[0] ? timestampToDate(createTime[0]) + ' 00:00:00' : null,
        b2c_term_end_time: createTime && createTime[1] ? timestampToDate(createTime[1]) + ' 23:59:59' : null
      }
      // 繁星-用户端-获取成员报表-下载
      const staffParams = {
        ..._listQuery,
        is_renewal: study_step ? study_step === '续报未截止' ? 1 : study_step === '续报已截止' ? 0 : null : null,
        is_unlock: study_step ? study_step === '首课未开课' ? 1 : study_step === '首课已开课' ? 0 : null : null,
        start_date: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_date: createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        pageSize: total || 1000
      }
      delete paramsTrial.payType;
      delete paramsOfficial.payType;
      const finalParams = (pageType === 'trial' || pageType === 'thirdpartyTrial') ? paramsTrial
        : pageType === 'official' ? paramsOfficial
          : pageType === 'link' ? paramsLink
            : (pageType === 'channel' || pageType === 'org') ? paramsChannel
              : (pageType === 'timeChannel' || pageType === 'timeOrg') ? staffParams
                : pageType === 'staffOrg' ? staffParams : baseParams;
      this.downloadParam = finalParams;
      const apiPath = pageType === 'official' ? 'boutique-orders/download'
        : pageType === 'link' ? 'agent/link/list/excel'
          : pageType === 'channel' ? 'star/teamChannel/download'
            : pageType === 'org' ? 'star/team/download'
              : pageType === 'timeChannel' ? dimension === 'sum' ? 'star/links/forms/sum/download' : 'star/links/forms/download'
                : pageType === 'timeOrg' ? dimension === 'sum' ? 'star/teams/forms/sum/download' : 'star/teams/forms/download'
                  : pageType === 'trial' ? 'trail-orders/download'
                    : pageType === 'thirdpartyTrial' ? 'third-trial-orders/download'
                      : pageType === 'staffOrg' ? dimension === 'sum' ? 'star/members/forms/sum/download'
                        : 'star/members/forms/download' : '';
      this.apiPath = apiPath;
      const excelName = pageType === 'official' ? '精品课订单'
        : pageType === 'link' ? '推广链接'
          : pageType === 'channel' ? '推广渠道报表(公益课)'
            : pageType === 'org' ? '团队报表(公益课)'
              : pageType === 'timeChannel' ? dimension === 'sum' ? '推广链接报表(累计)' : '推广链接报表'
                : pageType === 'timeOrg' ? '团队报表'
                  : (pageType === 'trial' || pageType === 'thirdpartyTrial') ? '体验课订单'
                    : pageType === 'staffOrg' ? dimension === 'sum' ? `${isThirdParty ? '达人' : '成员'}报表(累计)`
                      : `${isThirdParty ? '达人' : '成员'}报表` : '';
      exportExcel({
        params: delUndefined(finalParams),
        apiPath
      }).then(res => {
        if (res.data && res.data.errCode && Number(res.data.errCode) > 0) {
          this.loading.close();
          this.alertBox(`导出失败${res.data.errMsg ? `，${res.data.errMsg}` : ''}`)
          return
        }
        if (res.data && res.data.type && res.data.type === 'application/json') {
          this.loading.close();
          const fr = new FileReader()
          fr.onload = (e) => {
            const result = e && e.target && e.target.result ? JSON.parse(e.target.result) : null
            this.alertBox(`导出失败${result && result.errMsg ? `，${result.errMsg}` : ''}`)
          }
          fr.readAsText(res.data)
          return
        }
        if (res) {
          setTimeout(() => {
            this.loading.close();
          }, 1000)
          const blob = new Blob([res]);
          const downloadElement = document.createElement('a');
          const objectUrl = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = objectUrl;
          downloadElement.download = `${excelName}.csv`; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl);
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.btnCreate{
    margin: 3px auto 30px 20px;
    background: #FF9900;
    color: #fff;
    border: 1px solid #FF9900;
}
.btnCreate:hover{
    background: #FFA94C;
    border: 1px solid #FFA94C;
}
.btn{
  float: right;
}
</style>
